import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { WidgetEdit } from '../../../../shared/components/widget-edit/widget-edit';
import { ModalService } from '../../../../shared/services/modal.service';

@Component({
  selector: 'app-upcoming-bills-widget',
  standalone: true,
  imports: [CommonModule, CdkOverlayOrigin, WidgetEdit],
  templateUrl: './upcoming-bills.html',
  styleUrls: ['./upcoming-bills.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpcomingBills {
  @Input() title = 'Upcoming Bills';
  @Input() size: 'small' | 'medium' | 'half' | 'full' = 'medium';
  @Input() index = 0;
  @Input() isEditMode = false;
  @Input() isAddMode = false;
  @Output() addWidget = new EventEmitter<void>();
  @Input() activeDropdownIndex: number | null = null;
  @Input() getAvailableSizes!: (index: number) => Array<{ value: string; label: string }>;
  @Input() toggleSizeDropdown!: (index: number, event: Event) => void;
  @Input() changeWidgetSize!: (index: number, size: any) => void;
  @Input() removeWidget!: (index: number) => void;

  constructor(private modalService: ModalService) { }

  openModal() {
    if (!this.isEditMode && !this.isAddMode) {
      this.modalService.openUpcomingBillsModal();
    }
  }
}